<ol class="my-breadcrumb">
  @for (breadcrumb of breadcrumbs; track breadcrumb) {
    <li>
      <span [routerLink]="breadcrumb.url" routerLinkActive="router-link-active" [innerHTML]="translationService.getTranslation('breadcrumb_' + breadcrumb.label)">
      </span>
    </li>
  }
</ol>
